export default {
    access_or_improved_road: {
        name: "Access Or Improved Road",
        url: "nwcg_lines_reference/access_or_improved_road",
    },
    fence: {
        name: "Fence",
        url: "nwcg_lines_reference/fence",
    },
    highlighted_feature: {
        name: "Highlighted Feature",
        url: "nwcg_lines_reference/highlighted_feature",
    },
    management_action_point: {
        name: "Management Action Point",
        url: "nwcg_lines_reference/management_action_point",
    },
    other: {
        name: "Other",
        url: "nwcg_lines_reference/other",
    },
}
